import { Component, OnInit } from '@angular/core';
import { PaymentService } from '../../../../services/payment.service';
import { MessageService } from 'primeng/api';
import { HelpersService } from '../../../../services/helpers.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CardDetailsComponent } from '../../../modals/card-details/card-details.component';
import { CancelPackageComponent } from '../../../modals/cancel-package/cancel-package.component';
import { TranslateService } from '@ngx-translate/core';
import { CountriesService } from '../../../../services/countries.service';
import { BroadcastService } from '../../../../services/broadcast.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-record-payment-details',
  templateUrl: './record-payment-details.component.html',
  styleUrls: ['./record-payment-details.component.scss'],
  providers: [MessageService],
})
export class RecordPaymentDetailsComponent implements OnInit {
  public packages = [];

  public billingOptions = ['Annually', 'Monthly'];
  public selectedBilling = 'Annually';
  public pricing = 0;
  public currencySymbol = '';
  public loading = false;
  public basicPackage;
  public basicPrice;
  public generalPackage;
  public generalPrice;
  public largePackage;
  public largePrice;
  public currency;
  public stripePortalURL: string = null;
  public stripeCustomerID: string = null;
  public stripeProductID: string = null;
  public stripeSubscriptionID: string = null;
  public subscription;
  any = null;

  public plans: any = [
    {
      planName: this.translate.instant('bikeshop.account.plan_basic'),
      extraInfo: this.translate.instant('bikeshop.account.plan_basic_info'),
      includes: [
        this.translate.instant('bikeshop.account.plan_basic_technicians'),
        this.translate.instant('bikeshop.account.integration_into_pos'),
        this.translate.instant('bikeshop.account.customer_and_bike_history'),
        this.translate.instant('bikeshop.account.all_platforms_pc_mac_ipad'),
        this.translate.instant('bikeshop.account.unlimited_services'),
        this.translate.instant('bikeshop.account.support'),
        this.translate.instant('bikeshop.account.calendar'),
        this.translate.instant('bikeshop.account.lite_sms'),
      ],
    },
    {
      planName: this.translate.instant('bikeshop.account.plan_business'),
      extraInfo: this.translate.instant('bikeshop.account.plan_business_info'),
      includes: [
        this.translate.instant('bikeshop.account.plan_business_technicians'),
        this.translate.instant('bikeshop.account.analytics_on_the_bike_shop'),
        this.translate.instant('bikeshop.account.online_booking_widget'),
        this.translate.instant('bikeshop.account.pro_sms'),
      ],
    },
    {
      planName: this.translate.instant('bikeshop.account.plan_enterprise'),
      extraInfo: this.translate.instant(
        'bikeshop.account.plan_enterprise_info',
      ),
      includes: [
        this.translate.instant('bikeshop.account.plan_enterprise_technicians'),
        this.translate.instant('bikeshop.account.includes_loyalty_program'),
        this.translate.instant('bikeshop.account.premium_sms'),
      ],
    },
  ];

  constructor(
    public helpersService: HelpersService,
    public paymentService: PaymentService,
    public modalService: NgbModal,
    public messageService: MessageService,
    public translate: TranslateService,
    public countriesService: CountriesService,
    private broadcastService: BroadcastService,
    private router: Router,
  ) {}

  ngOnInit() {
    const partner = this.helpersService.getPartnerData();
    this.getPortalSessionInfo();
    this.countriesService.getAllCountries().subscribe(
      (res) => {
        var country = res
          .filter((x) => {
            return x.code.toUpperCase() === partner.Country.toUpperCase();
          })
          .pop();
        if (country) {
          this.currency = country.currency.toLowerCase();
          this.currencySymbol = country.currencySymbol;
        } else {
          this.currency = 'usd';
          this.currencySymbol = '$';
        }
      },
      (err) => {
        this.currency = 'usd';
        this.currencySymbol = '$';
      },
    );
  }

  getPortalSessionInfo() {
    this.loading = true;
    this.paymentService
      .getStripePortalSession(
        this.helpersService.getPartnerId(),
        window.location.href,
      )
      .subscribe(
        (res) => {
          if (res.portalSession && res.portalSession.url) {
            this.stripePortalURL = res.portalSession.url;
            this.stripeCustomerID = res.stripeCustomerID;
            this.stripeProductID = res.stripeProductID;
            this.stripeSubscriptionID = res.stripeSubscriptionID;
            this.subscription = res.subscription;
          }
          this.broadcastService.sendMessage({ payment: true });
          this.paymentService.getPackagesStripe().subscribe(
            (res) => {
              this.loading = false;
              res.forEach((element) => {
                var currencySymbol = this.currencySymbol;
                var pricing = element.pricing
                  .filter((el) => el.currency === this.currency)
                  .pop();

                //Failover to USD if there are no prices
                if (pricing === undefined) {
                  pricing = element.pricing
                    .filter((el) => el.currency === 'usd')
                    .pop();
                  currencySymbol = '$';
                }

                element.pricing = pricing; //Do not remove this - used in the modal, trying to make the best out of Ians crappy plan

                if (pricing) {
                  switch (element.name) {
                    case 'Hubtiger - Enterprise':
                      this.largePrice = pricing.amount / 100;
                      this.largePackage = element;
                      this.plans[2].price =
                        currencySymbol + pricing.amount / 100;
                      this.plans[2].package = element;
                      this.plans[2].id = element.id;
                      break;
                    case 'Hubtiger - Business':
                      this.generalPrice = pricing.amount / 100;
                      this.generalPackage = element;
                      this.plans[1].price =
                        currencySymbol + pricing.amount / 100;
                      this.plans[1].package = element;
                      this.plans[1].id = element.id;
                      break;
                    case 'Hubtiger - Basic':
                      this.basicPrice = pricing.amount / 100;
                      this.basicPackage = element;
                      this.plans[0].price =
                        currencySymbol + pricing.amount / 100;
                      this.plans[0].package = element;
                      this.plans[0].id = element.id;
                      break;
                  }
                }
              });
            },
            (error) => {
              this.loading = false;
            },
          );
        },
        (err) => {
          this.loading = false;
        },
      );
  }

  chosePackage(chosenPackage) {
    console.log(chosenPackage);

    const partner = this.helpersService.getPartnerData();
    if (partner.POSSystemID == 9) {
      this.paymentService
        .checkIfSignedUpUsingShopify(partner.ID)
        .subscribe((rep) => {
          if (rep.IsShopifyConnection) {
            this.paymentService
              .createShopifyPaymentIntent(partner.ID, chosenPackage)
              .subscribe((resp) => {
                //window.top.location.href = (resp.confirmation_url);
                window.open(resp.confirmation_url, '_self');
                //this.router.navigateByUrl(resp.confirmation_url)
              });
          } else {
            if (!this.loading && chosenPackage && !this.stripeProductID) {
              const modalRef = this.modalService.open(CardDetailsComponent, {
                size: 'lg',
                backdrop: 'static',
                windowClass: 'user-modal',
              });
              modalRef.componentInstance.chosenPackage = chosenPackage;
              modalRef.componentInstance.messageService = this.messageService;
              modalRef.result.then((res) => {
                this.getPortalSessionInfo();
              });
            }
          }
        });
    } else {
      if (!this.loading && chosenPackage && !this.stripeProductID) {
        const modalRef = this.modalService.open(CardDetailsComponent, {
          size: 'lg',
          backdrop: 'static',
          windowClass: 'user-modal',
        });
        modalRef.componentInstance.chosenPackage = chosenPackage;
        modalRef.componentInstance.messageService = this.messageService;
        modalRef.result.then((res) => {
          this.getPortalSessionInfo();
        });
      }
    }
  }

  cancelPackage(chosenPackage) {
    const modalRef = this.modalService.open(CancelPackageComponent, {
      size: 'lg',
      backdrop: 'static',
      windowClass: 'user-modal',
    });
  }

  openStripePortal() {
    window.open(this.stripePortalURL, '_self');
  }
}
